<template>
<div class="table-first-style">
  <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
    <el-row class="search-title">
      <el-col :span="4" class="table-title" style="text-align: left">
        <i class="el-icon-search" style="font-weight: bold;"></i>
        <span class="order-list-search-span">筛选查询</span>
      </el-col>
      <el-col :span="20" class="text-align-right" style="text-align: right">
        <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
        <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
        <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
        <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
        <el-button class="search-btn-new" type="primary" @click="load">查询</el-button>
      </el-col>
    </el-row>
    <el-row class="search-content common-search-formtype" style="text-align: left;line-height: 60px" v-show="hide">
      <el-col :span="24" class="text-align-left">
        <span style="margin-left: 26px">用户名/姓名：</span>
        <el-input clearable @keyup.enter.native="load" placeholder="用户名/姓名" v-model.trim="search.keyword" ></el-input>
<!--        <span style="margin-left: 26px">所属部门：</span>-->
<!--        <el-select filterable v-model="search.structure_id" placeholder="全部部门">-->
<!--          <el-option-->
<!--            v-for="item in structures"-->
<!--            :key="item.id"-->
<!--            :label="item.name"-->
<!--            :value="item.id">-->
<!--          </el-option>-->
<!--        </el-select>-->
      </el-col>
    </el-row>
  </div>
  <el-row class="search-title common-table-top" style="padding-right:0">
    <el-col :span="4" class="table-title" style="text-align: left">
      <i class="el-icon-document" style="font-weight: bold;"></i>
      <span>用户列表</span>
    </el-col>
    <el-col :span="20" class="text-align-right">
      <el-button type="primary" class="add-btn btn-right" v-show="btnType.add" @click="toAdd">新建</el-button>
    </el-col>
  </el-row>
  <el-table
  :data="tableData"
  v-loading="loading">
    <template slot="empty">
      <div class="newTableEmpty">暂无数据，去<span @click="toAdd">新建</span></div>
    </template>
    <el-table-column
            label="姓名"
            prop="realname">
    </el-table-column>
    <el-table-column
    prop="username"
    label="账号">
    </el-table-column>
<!--    <el-table-column-->
<!--    label="联系电话"-->
<!--    prop="mobile"-->
<!--    width="150">-->
<!--    </el-table-column>-->
    <el-table-column
      label="所属部门"
      prop="deptName"
      width="">
    </el-table-column>
    <el-table-column
      label="角色"
      prop="roleName"
      width="">
    </el-table-column>
    <el-table-column
      label="是否启用"
      prop="status">
      <template slot-scope="scope">
        <!-- 传值 1正常 0禁用 -->
<!--        <div class="op-link" @click="switchChange(scope.row)">-->
<!--          {{ scope.row.state === 1 ? '禁用':'启用' }}-->
<!--        </div>-->
        <el-switch
                v-show="btnType.status_change"
                @change="switchChange(scope.row)"
                v-model="scope.row.state"
                :active-value="activeValue"
                :inactive-value="activeValueNo">
        </el-switch>
      </template>
    </el-table-column>
    <el-table-column
    label="操作"
    width="220">
      <!--<template slot-scope="scope">-->
        <!--<div class="op-link">-->
          <!--<span>-->
            <!--<el-button type="primary" size="small" @click="toEdit(scope.row.id)" class="editBtn">-->
            <!--编辑-->
            <!--</el-button>-->
          <!--</span>-->
          <!--<span>-->
            <!--<el-button size="small" type="danger" class="removeBtn" @click="confirmDelete(scope.row)">删除</el-button>-->
          <!--</span>-->
        <!--</div>-->
      <!--</template> &ndash;&gt;-->
      <template slot-scope="scope">
        <div class="op-link editColor" v-show="btnType.edit" @click="toEdit(scope.row)">
          编辑
        </div>
        <div class="op-link deleteColor" v-show="btnType.del" @click="confirmDelete(scope.row)">
          删除
        </div>
        <div class="op-link" v-show="btnType.del" @click="openDataPower(scope.row)">
          小程序权限
        </div>
      </template>
    </el-table-column>
  </el-table>
  <div class="pos-rel p-t-20">
    <div class="table-foot">
      <el-pagination
        class="table-foot-pagination totalPage"
        background
        @size-change="handleSizeChangeTotal"
        @current-change="handleCurrentChangeTotal"
        :page-size="limit"
        :current-page="page"
        layout="total, prev, pager, next, jumper"
        :total="totalCountTotal">
      </el-pagination>
    </div>
  </div>
  <!--小程序权限弹窗-->
  <el-dialog class="cellDialog base-dialog" title="小程序权限" :visible.sync="dataPowerdialog" width="520px">
    <el-form :model="dataPowerForm">
      <el-form-item label="姓名：" label-width="100px">
        <span class="datapowerspan">{{realname}}</span>
      </el-form-item>
      <el-form-item label="账号：" label-width="100px">
        <span class="datapowerspan">{{username}}</span>
      </el-form-item>
      <el-form-item label="业务区域：" label-width="100px">
        <el-radio-group v-model="dataPowerForm.searchPermissions" @change="changeRadio">
          <el-radio :label="1">全部</el-radio>
          <el-radio :label="2">指定业务区域</el-radio>
        </el-radio-group>
        <el-select v-show="areaSelect" v-model="areaIdList" multiple filterable :filter-method="searchHandel" :loading="arealoading" clearable placeholder="请选择业务区域" style="width:100%;">
          <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel-btn" @click="dataPowerdialog = false" style="margin-right: 20px">取 消</el-button>
      <el-button class="dialog-confirm-btn" style="margin-right: 30px" type="primary" @click="confirmDataPower">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getMemberList, deleteMemberList, stateMemberList,butonsList,getMenId, businessAreaList, businessAreaDetail, saveUserArea } from '@/api/analyse.js'
export default {
  data() {
    return {
      activeValueNo: 0,
      activeValue: 1,
      loading: true,
      hide: true,
      tableData: [],
      totalCountTotal: 0,
      currentPage: null,
      structures: [],
      limit: 10,
      page: 1,
      click: 1,
      search: {
        pageNum: 1,
        pageSize: 10,
        keyword: ''
      },
      btnType:{
        'status_change':false,
        'add':false,
        'edit':false,
        'del':false
      },
      // 小程序权限弹窗
      dataPowerdialog: false,
      realname: '',
      username: '',
      dataPowerForm: {
        id: '',
        searchPermissions: 1,
        areaIdList: ''
      },
      // 业务区域下拉框
      areaSelect: true,
      areaname: '',
      areaIdList: [],
      areaList: [],
      arealoading: false
    }
  },
  methods: {
    // 小程序数据权限
    openDataPower(row) {
      console.log(row, 'row')
      this.dataPowerdialog = true
      this.realname = row.realname
      this.username = row.username
      row.searchPermissions = row.searchPermissions?row.searchPermissions:1
      if(row.searchPermissions === 1) {
        this.areaSelect = false
      } else {
        this.areaSelect = true
      }
      this.dataPowerForm.id = row.id
      this.dataPowerForm.searchPermissions = row.searchPermissions
      if (!row.areaIdList) return
      this.areaIdList = row.areaIdList.split(',').map(Number)
      console.log(this.areaIdList)
      this.getArea()
    },
    changeRadio (val) {
      if(val === 2) {
        this.areaSelect = true
      } else {
        this.areaSelect = false
      }
      this.areaIdList = []
    },
    // 业务区域下拉框
    searchHandel(val){
      this.arealoading = true
      this.areaList = []
      this.areaname = val
      this.getArea()
    },
    getArea () {
      let params = {
        pageNum:1,
        pageSize:20,
        name:this.areaname
      }
      businessAreaList(params).then(res => {
        if (res.data.code == 200) {
          this.areaList = res.data.result.list
          this.areaList = [...new Set(this.areaList)]
          if(this.areaIdList.length > 0) {
            this.areaIdList.forEach(item => {
              var isExits = this.isExist(item)
              if(!isExits){
                businessAreaDetail({id:item}).then(res=>{
                  this.areaList.push(res.data.result)
                })
              }
            })
          }
        }
        this.arealoading = false
      })
    },
    // 根据业务区域id回显业务区域
    isExist(id) {
      var nom = true
      for(let i = 0, k = this.areaList.length; i < k; i ++){
        if(this.areaList[i].id === id){
          nom = true
          break
        }else{
          nom = false
        }
      }
      return nom
    },
    // 修改小程序数据权限
    confirmDataPower() {
      this.dataPowerForm.areaIdList = this.areaIdList.join(',')
      if (this.dataPowerForm.searchPermissions === 2 && !this.dataPowerForm.areaIdList) {
        return _g.toastMsg('error', '请选择业务区域')
      }
      saveUserArea(this.dataPowerForm).then(res => {
        if (res.data.code === '200') {
           _g.toastMsg('success', '设置成功')
        } else {
           _g.toastMsg('error', res.data.message)
        }
        this.dataPowerdialog = false
        this.load()
      })
    },
    // 跳转都编辑
    toEdit(row) {
      // sessionStorage.setItem('memberInfoDetail', JSON.stringify(row))
      router.push({name: 'userEdit', query: { id: row.id }})
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    // 跳转到添加成员
    toAdd() {
      router.push('/home/administrative/user-add')
    },
    // 分页
    handleSizeChangeTotal(val) {
      this.search.pageSize = val
      this.load()
    },
    handleCurrentChangeTotal(page) {
      this.search.pageNum = page
      this.load()
    },
    // 启用禁用
    switchChange(item) {
      // item.state = item.state === 0 ? 1 : 0
      if (this.click === 1) {
        this.click = 0
        this.$nextTick(() => {
          stateMemberList({
            state: item.state,
            id: item.id
          }).then((res) => {
            if (res.data.code === '200') {
              _g.toastMsg('success', res.data.message)
              this.load()
              this.click = 1
            } else {
              _g.toastMsg('error', res.data.message)
            }
          })
        })
      }
    },
    // 查询加载
    load() {
      this.loading = true
      let params = this.search
      getMemberList(params).then((res) => {
        if (res.data.code === '200') {
          this.tableData = res.data.result.list || []
          this.totalCountTotal = res.data.result.total
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 删除成员
    confirmDelete(item) {
      this.$confirm('确认删除该成员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMemberList({id: item.id}).then((res) => {
          if (res.data.code === '200') {
            _g.toastMsg('success', '删除成功')
            this.load()
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      })
    },
    init() {
      this.load()
    }
  },
  created() {
    this.search.pageNum = 1
    this.load()
    this.queryBtnList()
    this.getArea()
  }
}
</script>
<style scoped>
.base-dialog >>> .el-form-item__content {
  text-align: left!important;
}
.base-dialog >>> .el-form-item__content {
  height: auto;
}
.base-dialog >>> .el-input {
  height: auto;
}
.base-dialog >>> .el-input__inner {
  height: auto;
}
</style>
